module.exports = __webpack_public_path__ + "img/icon_logo_2.da0fd2dd.png";